import React, { useEffect } from 'react';
import { useAppAuth } from '../auth/appAuth';

const Logout: React.FC = () => {
  const { logout } = useAppAuth();

  useEffect(() => {
    logout({
      logoutParams: {
        returnTo: window.location.origin, // Redirect after logout
      },
    });
  }, [logout]);

  return (
    <div style={{ textAlign: 'center', marginTop: '40px' }}>
      Logging out...
    </div>
  );
};

export default Logout;